import { RevisionBulkActionProps, RevisionRow } from 'components/tables/data/revision/types';

import Button from 'components/Button';
import { IconRubberStamp } from '@tabler/icons-react';
import useConfirmAction from 'components/tables/data/revision/actions/hooks/use-confirm-action';
import { noop } from 'lodash';
import BulkConfirmMessage from 'components/tables/data/revision/actions/bulk/BulkConfirmMessage';
import { useConfirm } from 'components/modals/message/MessageProvider';
import { getBulkRevisionKindGroup } from 'components/tables/data/revision/actions/bulk/kind-utils';

/**
 * Performs a bulk confirm on all selected rows.
 */
export default function BulkConfirmAction({
  revisions,
  onStatusChange = noop,
  onBulkActionComplete = noop,
}: RevisionBulkActionProps) {
  const { confirm } = useConfirm();
  const { confirmRevision } = useConfirmAction();
  const availableRevisions: RevisionRow[] =
    getBulkRevisionKindGroup(revisions) === 'mixed'
      ? []
      : revisions.filter(
          (revision) =>
            revision.revisionStatus.slug === 'approved-waiting-for-confirmation' && revision.actionPermissions.canAccept
        );

  /**
   * Confirms all selected revisions.
   */
  const confirmAll = () =>
    confirm({
      title: availableRevisions[0]?.kind === 'revision' ? 'Prebrať revízne správy' : 'Prebrať formuláre',
      content: (
        <BulkConfirmMessage
          message={
            availableRevisions[0]?.kind === 'revision'
              ? 'Naozaj si prajete prebrať vybrané revízne správy?'
              : 'Naozaj si prajete prebrať vybrané formuláre?'
          }
          revisions={availableRevisions}
        />
      ),
      primaryButtonText: 'Prebrať',
      secondaryButtonText: 'Zrušiť',
      onConfirm: async () => {
        for (const revision of availableRevisions) {
          await confirmRevision({ revision, onStatusChange });
        }
        onBulkActionComplete();
      },
    });

  if (availableRevisions.length === 0) {
    return <></>;
  }

  return (
    <Button variant="primary" size="sm" leftIcon={<IconRubberStamp />} onClick={confirmAll}>
      Prebrať ({availableRevisions.length})
    </Button>
  );
}
